<template>
  <div>
    <!-- Header -->
    <div class="header pb-8" style="background-image: url(img/theme/hero-bg.jpg);">
    <b-nav align="right" class="mb-3" style="background-color: #ffffff7a">
      <b-nav-item to="login" class="text-primary mr-3"><i class="far fa-key"></i> Iniciar Sesión</b-nav-item>
    </b-nav>
      <!-- <b-container>
        <div class="header-body text-center mb-7">
          <b-row class="justify-content-center">
            <b-col xl="5" lg="6" md="8" class="px-5">
              <h1 class="text-white">Welcome!</h1>
              <p class="text-lead text-white">Use these awesome forms to login or create new account in your project for
                free.</p>
            </b-col>
          </b-row>
        </div>
      </b-container>-->
      <b-container>
        <b-row class="justify-content-center">
          <b-col class="text-center">
            <b-img fluid src="img/brand/nuevo_logo.svg" width="200px"></b-img>
          </b-col>
        </b-row>
      </b-container>
      <div class="separator separator-bottom separator-skew zindex-100">
        <svg
          x="0"
          y="0"
          viewBox="0 0 2560 100"
          preserveAspectRatio="none"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <polygon class="fill-info" points="2560 0 2560 100 0 100" />
        </svg>
      </div>
    </div>
    <!-- Page content -->
    <b-container class="mt-2 pb-5" fluid>
      <b-row class="justify-content-center">
        <b-col lg="8" md="10" class="text-center">
          <b-button to="facturar" variant="primary" style="min-width:250px">
            <h2 class="mb-0 text-white"><i class="fas fa-poll-h d-block fa-3x mb-2"></i> Facturación</h2>
          </b-button>
          <b-button to="descargar-cfdi" variant="primary" style="min-width:250px">
            <h2 class="mb-0 text-white"><i class="far fa-file-download d-block fa-3x mb-2"></i> Descargar CFDI</h2>
          </b-button>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
export default {
  data() {
    return {
      working: false,
      error: []
    };
  },
  beforeMount(){
  },
  methods: {
  }
};
</script>
